// removed by extract-text-webpack-plugin
module.exports = {"MessageWrapper":"MessageWrapper__Gh8ge","TimeLine":"TimeLine__2N4K6","TimeBody":"TimeBody__2TT8D","TimeMessage":"TimeMessage__8EVnx"};


//////////////////
// WEBPACK FOOTER
// ./routes/Chat/Chat/style.scss
// module id = gknL
// module chunks = 0